'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Channel {
  name: string;
  category: string;
  logo?: string;
  alt?: string;
  color?: string;
}

interface ChannelCategory {
  name: string;
  icon: string;
  count: number;
}

const ChannelsSection = () => {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeCategory, setActiveCategory] = useState('sport');

  const categories: ChannelCategory[] = [
  { name: 'sport', icon: 'TrophyIcon', count: 28 },
  { name: 'filmovi', icon: 'FilmIcon', count: 40 },
  { name: 'deca', icon: 'SparklesIcon', count: 30 },
  { name: 'vesti', icon: 'NewspaperIcon', count: 20 },
  { name: 'zabava', icon: 'MusicalNoteIcon', count: 35 },
  { name: 'dokumentarci', icon: 'AcademicCapIcon', count: 25 }];


  const channels: Channel[] = [
  {
    name: 'Arena Sport 1',
    category: 'sport',
    color: '#e74c3c'
  },
  {
    name: 'Arena Sport 2',
    category: 'sport',
    color: '#3498db'
  },
  {
    name: 'Adrenalin',
    category: 'sport',
    color: '#c0392b'
  },
  {
    name: 'Arena Tenis',
    category: 'sport',
    color: '#27ae60'
  },
  {
    name: 'Arena 4 Premium',
    category: 'sport',
    color: '#16a085'
  },
  {
    name: 'Arena 5 Premium',
    category: 'sport',
    color: '#8e44ad'
  },
  {
    name: 'Eurosport 1',
    category: 'sport',
    color: '#f39c12'
  },
  {
    name: 'HBO',
    category: 'filmovi',
    color: '#2c3e50'
  },
  {
    name: 'Cinemax',
    category: 'filmovi',
    color: '#e74c3c'
  },
  {
    name: 'Fox Movies',
    category: 'filmovi',
    color: '#3498db'
  },
  {
    name: 'AXN',
    category: 'filmovi',
    color: '#34495e'
  },
  {
    name: 'Nickelodeon',
    category: 'deca',
    color: '#e67e22'
  },
  {
    name: 'Cartoon Network',
    category: 'deca',
    color: '#2ecc71'
  },
  {
    name: 'Disney Channel',
    category: 'deca',
    color: '#3498db'
  },
  {
    name: 'Baby TV',
    category: 'deca',
    color: '#9b59b6'
  },
  {
    name: 'CNN',
    category: 'vesti',
    color: '#e74c3c'
  },
  {
    name: 'BBC World',
    category: 'vesti',
    color: '#2c3e50'
  },
  {
    name: 'Al Jazeera',
    category: 'vesti',
    color: '#f39c12'
  },
  {
    name: 'RTS 1',
    category: 'vesti',
    color: '#3498db'
  },
  {
    name: 'MTV',
    category: 'zabava',
    color: '#e67e22'
  },
  {
    name: 'E! Entertainment',
    category: 'zabava',
    color: '#e91e63'
  },
  {
    name: 'Comedy Central',
    category: 'zabava',
    color: '#f1c40f'
  },
  {
    name: 'VH1',
    category: 'zabava',
    color: '#e74c3c'
  },
  {
    name: 'National Geographic',
    category: 'dokumentarci',
    color: '#f39c12'
  },
  {
    name: 'Discovery',
    category: 'dokumentarci',
    color: '#3498db'
  },
  {
    name: 'History',
    category: 'dokumentarci',
    color: '#8b4513'
  },
  {
    name: 'Animal Planet',
    category: 'dokumentarci',
    color: '#27ae60'
  }];


  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const filteredChannels = channels.filter(
    (channel) => channel.category === activeCategory
  );

  if (!isHydrated) {
    return (
      <section data-component-id="src/app/landing-page/components/ChannelsSection.tsx:182:6" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="182" data-component-end-line="193" data-component-file="ChannelsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22className%22%3A%22py-20%20bg-muted%22%7D" className="py-20 bg-muted">
        <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:183:8" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="183" data-component-end-line="192" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:184:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="184" data-component-end-line="191" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
            <h2 data-component-id="src/app/landing-page/components/ChannelsSection.tsx:185:12" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="185" data-component-end-line="187" data-component-file="ChannelsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20sm%3Atext-4xl%20lg%3Atext-5xl%20font-heading%20font-black%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22230%2B%20Premium%20kanala%22%7D" className="text-3xl sm:text-4xl lg:text-5xl font-heading font-black text-foreground mb-4">
              230+ Premium kanala
            </h2>
            <p data-component-id="src/app/landing-page/components/ChannelsSection.tsx:188:12" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="188" data-component-end-line="190" data-component-file="ChannelsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xl%20text-muted-foreground%20max-w-3xl%20mx-auto%22%2C%22textContent%22%3A%22Sport%2C%20filmovi%2C%20de%C4%8Diji%20program%2C%20vesti%20i%20jo%C5%A1%20mnogo%20toga%22%7D" className="text-xl text-muted-foreground max-w-3xl mx-auto">
              Sport, filmovi, dečiji program, vesti i još mnogo toga
            </p>
          </div>
        </div>
      </section>);

  }

  return (
    <section data-component-id="src/app/landing-page/components/ChannelsSection.tsx:198:4" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="198" data-component-end-line="292" data-component-file="ChannelsSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22channels%22%2C%22className%22%3A%22py-20%20bg-muted%22%7D" id="channels" className="py-20 bg-muted">
      <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:199:6" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="199" data-component-end-line="291" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-7xl%20mx-auto%20px-4%20sm%3Apx-6%20lg%3Apx-8%22%7D" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:200:8" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="200" data-component-end-line="207" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22text-center%20mb-16%22%7D" className="text-center mb-16">
          <h2 data-component-id="src/app/landing-page/components/ChannelsSection.tsx:201:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="201" data-component-end-line="203" data-component-file="ChannelsSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22text-3xl%20sm%3Atext-4xl%20lg%3Atext-5xl%20font-heading%20font-black%20text-foreground%20mb-4%22%2C%22textContent%22%3A%22230%2B%20Premium%20kanala%22%7D" className="text-3xl sm:text-4xl lg:text-5xl font-heading font-black text-foreground mb-4">
            230+ Premium kanala
          </h2>
          <p data-component-id="src/app/landing-page/components/ChannelsSection.tsx:204:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="204" data-component-end-line="206" data-component-file="ChannelsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xl%20text-muted-foreground%20max-w-3xl%20mx-auto%22%2C%22textContent%22%3A%22Sport%2C%20filmovi%2C%20de%C4%8Diji%20program%2C%20vesti%20i%20jo%C5%A1%20mnogo%20toga%22%7D" className="text-xl text-muted-foreground max-w-3xl mx-auto">
            Sport, filmovi, dečiji program, vesti i još mnogo toga
          </p>
        </div>

        <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:209:8" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="209" data-component-end-line="232" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-center%20gap-4%20mb-12%22%7D" className="flex flex-wrap justify-center gap-4 mb-12">
          {categories.map((category) =>
          <button data-component-id="src/app/landing-page/components/ChannelsSection.tsx:211:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="211" data-component-end-line="230" data-component-file="ChannelsSection.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
            key={category.name}
            onClick={() => setActiveCategory(category.name)}
            className={`flex items-center space-x-2 px-6 py-3 rounded-xl font-heading font-bold transition-all duration-250 ${
            activeCategory === category.name ?
            'bg-primary text-primary-foreground shadow-conversion scale-105' :
            'bg-white text-foreground hover:bg-white/80 shadow-sm hover:shadow-md'}`
            }>

              <Icon data-component-id="src/app/landing-page/components/ChannelsSection.tsx:220:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="220" data-component-end-line="220" data-component-file="ChannelsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={category.icon as any} size={20} />
              <span data-component-id="src/app/landing-page/components/ChannelsSection.tsx:221:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="221" data-component-end-line="221" data-component-file="ChannelsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22capitalize%22%7D" className="capitalize">{category.name}</span>
              <span data-component-id="src/app/landing-page/components/ChannelsSection.tsx:222:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="222" data-component-end-line="229" data-component-file="ChannelsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%7D"
              className={`px-2 py-1 rounded-full text-xs font-bold ${
              activeCategory === category.name ?
              'bg-white/20 text-white' : 'bg-muted text-muted-foreground'}`
              }>

                {category.count}
              </span>
            </button>
          )}
        </div>

        <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:234:8" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="234" data-component-end-line="269" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-3%20md%3Agrid-cols-4%20gap-6%20mb-12%22%7D" className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 mb-12">
          {filteredChannels.map((channel, index) =>
          <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:236:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="236" data-component-end-line="267" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-white%20rounded-xl%20overflow-hidden%20shadow-conversion%20hover%3Ashadow-lg%20transition-all%20duration-250%20hover%3Ascale-105%20animate-in%20fade-in%22%7D"
            key={index}
            className="bg-white rounded-xl overflow-hidden shadow-conversion hover:shadow-lg transition-all duration-250 hover:scale-105 animate-in fade-in"
            style={{
              animationDelay: `${index * 50}ms`,
              animationFillMode: 'backwards'
            }}>

              <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:244:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="244" data-component-end-line="261" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22aspect-video%20relative%20overflow-hidden%20bg-muted%22%7D" className="aspect-video relative overflow-hidden bg-muted">
                {channel.color ? (
                  <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:246:18" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="246" data-component-end-line="253" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20h-full%20flex%20items-center%20justify-center%22%7D" 
                    className="w-full h-full flex items-center justify-center"
                    style={{ backgroundColor: channel.color }}
                  >
                    <span data-component-id="src/app/landing-page/components/ChannelsSection.tsx:250:20" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="250" data-component-end-line="252" data-component-file="ChannelsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-white%20font-heading%20font-bold%20text-lg%20px-4%20text-center%22%7D" className="text-white font-heading font-bold text-lg px-4 text-center">
                      {channel.name}
                    </span>
                  </div>
                ) : (
                  <AppImage data-component-id="src/app/landing-page/components/ChannelsSection.tsx:255:18" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="255" data-component-end-line="259" data-component-file="ChannelsSection.tsx" data-component-name="AppImage" data-component-content="%7B%22elementName%22%3A%22AppImage%22%2C%22className%22%3A%22w-full%20h-full%20object-cover%22%7D"
                    src={channel.logo || ''}
                    alt={channel.alt || ''}
                    className="w-full h-full object-cover"
                  />
                )}
              </div>
              <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:262:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="262" data-component-end-line="266" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22p-4%22%7D" className="p-4">
                <h3 data-component-id="src/app/landing-page/components/ChannelsSection.tsx:263:16" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="263" data-component-end-line="265" data-component-file="ChannelsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22font-heading%20font-bold%20text-foreground%20text-center%22%7D" className="font-heading font-bold text-foreground text-center">
                  {channel.name}
                </h3>
              </div>
            </div>
          )}
        </div>

        <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:271:8" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="271" data-component-end-line="290" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-gradient-to-r%20from-secondary%20to-primary%20rounded-2xl%20p-8%20text-center%20shadow-conversion%22%7D" className="bg-gradient-to-r from-secondary to-primary rounded-2xl p-8 text-center shadow-conversion">
          <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:272:10" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="272" data-component-end-line="289" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22max-w-3xl%20mx-auto%22%7D" className="max-w-3xl mx-auto">
            <h3 data-component-id="src/app/landing-page/components/ChannelsSection.tsx:273:12" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="273" data-component-end-line="275" data-component-file="ChannelsSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-2xl%20sm%3Atext-3xl%20font-heading%20font-black%20text-white%20mb-4%22%2C%22textContent%22%3A%22Arena%20Premium%20Sport%20uklju%C4%8Den!%22%7D" className="text-2xl sm:text-3xl font-heading font-black text-white mb-4">
              Arena Premium Sport uključen!
            </h3>
            <p data-component-id="src/app/landing-page/components/ChannelsSection.tsx:276:12" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="276" data-component-end-line="278" data-component-file="ChannelsSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-xl%20text-white%2F90%20mb-6%22%2C%22textContent%22%3A%22Gledajte%20sve%20sportske%20doga%C4%91aje%20u%C5%BEivo%20-%20fudbal%2C%20ko%C5%A1arka%2C%20tenis%20i%20vi%C5%A1e%22%7D" className="text-xl text-white/90 mb-6">
              Gledajte sve sportske događaje uživo - fudbal, košarka, tenis i više
            </p>
            <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:279:12" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="279" data-component-end-line="288" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-wrap%20justify-center%20gap-4%22%7D" className="flex flex-wrap justify-center gap-4">
              <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:280:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="280" data-component-end-line="283" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20space-x-2%20bg-white%2F20%20rounded-full%20px-6%20py-3%22%7D" className="inline-flex items-center space-x-2 bg-white/20 rounded-full px-6 py-3">
                <Icon data-component-id="src/app/landing-page/components/ChannelsSection.tsx:281:16" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="281" data-component-end-line="281" data-component-file="ChannelsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22TvIcon%22%2C%22className%22%3A%22text-white%22%7D" name="TvIcon" size={24} className="text-white" />
                <span data-component-id="src/app/landing-page/components/ChannelsSection.tsx:282:16" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="282" data-component-end-line="282" data-component-file="ChannelsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-white%20font-bold%22%2C%22textContent%22%3A%227-dana%20replay%22%7D" className="text-white font-bold">7-dana replay</span>
              </div>
              <div data-component-id="src/app/landing-page/components/ChannelsSection.tsx:284:14" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="284" data-component-end-line="287" data-component-file="ChannelsSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20items-center%20space-x-2%20bg-white%2F20%20rounded-full%20px-6%20py-3%22%7D" className="inline-flex items-center space-x-2 bg-white/20 rounded-full px-6 py-3">
                <Icon data-component-id="src/app/landing-page/components/ChannelsSection.tsx:285:16" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="285" data-component-end-line="285" data-component-file="ChannelsSection.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22PlayCircleIcon%22%2C%22className%22%3A%22text-white%22%7D" name="PlayCircleIcon" size={24} className="text-white" />
                <span data-component-id="src/app/landing-page/components/ChannelsSection.tsx:286:16" data-component-path="src/app/landing-page/components/ChannelsSection.tsx" data-component-line="286" data-component-end-line="286" data-component-file="ChannelsSection.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22text-white%20font-bold%22%2C%22textContent%22%3A%22Video%20klub%22%7D" className="text-white font-bold">Video klub</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default ChannelsSection;